/* exported LFPluginRemoveDots */

const LFPluginRemoveDots = (() => {
  const _config = {
    bindToEvent: "blur",
  };

  const removeDots = (input) => {
    input.value = input.value.split(".").join("");
  };

  return {
    event: _config.bindToEvent,
    run: removeDots,
  };
})();

export default LFPluginRemoveDots;
